var map = {
	"./": 318,
	"./Content": 1137,
	"./Content.dictionary": 1139,
	"./Content.dictionary.json": 1139,
	"./Content.jsx": 1137,
	"./ContentDeferred": 368,
	"./ContentDeferred.jsx": 368,
	"./InterestingMatches": 1019,
	"./InterestingMatches/": 1019,
	"./InterestingMatches/InterestingMatches.dictionary": 1035,
	"./InterestingMatches/InterestingMatches.dictionary.json": 1035,
	"./InterestingMatches/InterestingMatches.module.scss": 838,
	"./InterestingMatches/actions": 97,
	"./InterestingMatches/actions.ts": 97,
	"./InterestingMatches/components/Contetnt": 924,
	"./InterestingMatches/components/Contetnt/": 924,
	"./InterestingMatches/components/Contetnt/Content.dictionary": 970,
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": 970,
	"./InterestingMatches/components/Contetnt/Content.module.scss": 1034,
	"./InterestingMatches/components/Contetnt/index": 924,
	"./InterestingMatches/components/Contetnt/index.tsx": 924,
	"./InterestingMatches/components/Match": 842,
	"./InterestingMatches/components/Match/": 842,
	"./InterestingMatches/components/Match/Match.dictionary": 849,
	"./InterestingMatches/components/Match/Match.dictionary.json": 849,
	"./InterestingMatches/components/Match/index": 842,
	"./InterestingMatches/components/Match/index.tsx": 842,
	"./InterestingMatches/components/Sport": 969,
	"./InterestingMatches/components/Sport.tsx": 969,
	"./InterestingMatches/components/Stage": 875,
	"./InterestingMatches/components/Stage.tsx": 875,
	"./InterestingMatches/components/Tournament": 892,
	"./InterestingMatches/components/Tournament.jsx": 892,
	"./InterestingMatches/components/Union": 925,
	"./InterestingMatches/components/Union.jsx": 925,
	"./InterestingMatches/constants": 926,
	"./InterestingMatches/constants.ts": 926,
	"./InterestingMatches/index": 1019,
	"./InterestingMatches/index.jsx": 1019,
	"./InterestingMatches/reducer": 297,
	"./InterestingMatches/reducer/": 297,
	"./InterestingMatches/reducer/entities": 353,
	"./InterestingMatches/reducer/entities.js": 353,
	"./InterestingMatches/reducer/grid": 354,
	"./InterestingMatches/reducer/grid.js": 354,
	"./InterestingMatches/reducer/index": 297,
	"./InterestingMatches/reducer/index.js": 297,
	"./InterestingMatches/selectors": 829,
	"./InterestingMatches/selectors/": 829,
	"./InterestingMatches/selectors/entities": 275,
	"./InterestingMatches/selectors/entities.ts": 275,
	"./InterestingMatches/selectors/grid": 848,
	"./InterestingMatches/selectors/grid.ts": 848,
	"./InterestingMatches/selectors/index": 829,
	"./InterestingMatches/selectors/index.ts": 829,
	"./LandingPage.module.scss": 1178,
	"./MatchOfTheDay": 1020,
	"./MatchOfTheDay/": 1020,
	"./MatchOfTheDay/actions": 307,
	"./MatchOfTheDay/actions.ts": 307,
	"./MatchOfTheDay/components/Carousel": 971,
	"./MatchOfTheDay/components/Carousel/": 971,
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": 1138,
	"./MatchOfTheDay/components/Carousel/index": 971,
	"./MatchOfTheDay/components/Carousel/index.tsx": 971,
	"./MatchOfTheDay/components/MainStakes": 927,
	"./MatchOfTheDay/components/MainStakes/": 927,
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": 1036,
	"./MatchOfTheDay/components/MainStakes/index": 927,
	"./MatchOfTheDay/components/MainStakes/index.tsx": 927,
	"./MatchOfTheDay/components/MatchTile": 972,
	"./MatchOfTheDay/components/MatchTile/": 972,
	"./MatchOfTheDay/components/MatchTile/MatchDetails": 1037,
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": 1037,
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": 973,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": 1038,
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": 1038,
	"./MatchOfTheDay/components/MatchTile/index": 972,
	"./MatchOfTheDay/components/MatchTile/index.tsx": 972,
	"./MatchOfTheDay/images/background.svg": 1198,
	"./MatchOfTheDay/images/pattern.svg": 1199,
	"./MatchOfTheDay/index": 1020,
	"./MatchOfTheDay/index.tsx": 1020,
	"./MatchOfTheDay/reducer": 355,
	"./MatchOfTheDay/reducer.ts": 355,
	"./MatchOfTheDay/selectors": 885,
	"./MatchOfTheDay/selectors/": 885,
	"./MatchOfTheDay/selectors/entities": 285,
	"./MatchOfTheDay/selectors/entities.ts": 285,
	"./MatchOfTheDay/selectors/grid": 915,
	"./MatchOfTheDay/selectors/grid.ts": 915,
	"./MatchOfTheDay/selectors/index": 885,
	"./MatchOfTheDay/selectors/index.ts": 885,
	"./MatchOfTheDay/utils/get-match-ids-from-banners": 1080,
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": 1080,
	"./MiniBanners": 1021,
	"./MiniBanners/": 1021,
	"./MiniBanners/MiniBanners": 974,
	"./MiniBanners/MiniBanners.module.scss": 1039,
	"./MiniBanners/MiniBanners.tsx": 974,
	"./MiniBanners/components/Content": 893,
	"./MiniBanners/components/Content/": 893,
	"./MiniBanners/components/Content/Content": 876,
	"./MiniBanners/components/Content/Content.module.scss": 928,
	"./MiniBanners/components/Content/Content.tsx": 876,
	"./MiniBanners/components/Content/index": 893,
	"./MiniBanners/components/Content/index.ts": 893,
	"./MiniBanners/index": 1021,
	"./MiniBanners/index.ts": 1021,
	"./images/telegram.svg": 1200,
	"./index": 318,
	"./index.tsx": 318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1266;
module.exports = webpackContext;